import { useContext } from "react";

import { ReserveContext } from "@/context/ReserveProvider.context";

import type { ReserveContextType } from "@/context/ReserveProvider.context";

const useReserveContext = (): ReserveContextType => useContext(ReserveContext);

export default useReserveContext;
